import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { NewCategory } from "../../types/category";
import { RootState } from "../../app/store";
import { initialCategoryData } from "../../initial-state/initial-state";
import { CreateNewCategory } from "../setup/setupRequestBody";

const initialState = {
    categoryData: initialCategoryData,
}

const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
        populateCategory: ( state, action: PayloadAction<CreateNewCategory>) => {
            state.categoryData = action.payload;
        },
        updateCategory: ( state, action: PayloadAction<Partial<CreateNewCategory>>) => {
            state.categoryData = {
                ...state.categoryData,
                ...action.payload,
            };
        },
        clearCategory: (state) => {
            state.categoryData = initialCategoryData;
        },
    }
})

export const {
    populateCategory,
    updateCategory,
    clearCategory
} = categorySlice.actions;

export const selectCategorySlice = (state: RootState) => state.category.categoryData;

export default categorySlice.reducer;